/*
 * Created Date: 15-03-2024, 5:20:34 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Fri Mar 15 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import Image from 'mui-image'
import { useTranslation } from 'react-i18next'
import ErrorPageContainer from '../ErrorPageContainer'
import { Button } from '@mui/material'
import { Facebook, Message } from '@mui/icons-material'

const Page500 = () => {
	const { t } = useTranslation()
	return (
		<div className="p-5 md:py-28 md:px-60 flex h-full flex-col justify-center items-center bg-[#FFFFFF] gap-4">
			<div className="w-[90%] sm:w-[580px] xl:max-w-[920px]">
				<Image src="/assets/images/errors/500.svg" alt="500" />
			</div>

			<div className="flex flex-col items-center gap-20">
				<p className="text-[22px] m-0 leading-[28px] font-500 text-[#131214]">{t('Lỗi Server')}</p>
				<p className="text-[18px] m-0 leading-[24px] font-500 text-[#5E5C63] text-center">
					{t(
						'Rất xin lỗi, có một số vấn đề kĩ thuật đã xảy ra khi tải trang này. Mong bạn vui lòng thử lại sau.'
					)}
				</p>
				<p className="text-[16px] m-0 leading-[20px] font-500 text-[#9E9BA6] text-center">
					{t('Lỗi 500: Internal Server')}
				</p>
			</div>
			<div>
				<Button
					onClick={() => {
						// navigate(ROUTER_PERSONAL_DASHBOARD.dashboard)
					}}
					variant="main-gradient"
					// className="px-16 py-12 rounded-8 text-12 leading-20 font-500"
					startIcon={<Facebook />}
				>
					Liên hệ báo lỗi
				</Button>
			</div>
		</div>
	)
}
export default Page500
